import { Settings } from "@redotech/redo-model/team";

export const allowCustomerAccounts = (
  customerAccountSettings: Settings["customerAccounts"],
): boolean => {
  return !!customerAccountSettings?.enabled;
};
